import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const featureRootSelector = createFeatureSelector('productC14s');

export const getProductC14s = createSelector(featureRootSelector, (f) => f?.data);
export const productC14sIsLoading = createSelector(featureRootSelector, (f) => f?.productC14sLoading);
